import React, { useRef } from 'react';
import { useHover } from '@rio-cloud/rio-uikit';
import classNames from 'classnames';

export type StepStatus = 'completed' | 'ongoing' | 'draft';

interface CustomStepProgressProps {
    steps: { number: number; status: StepStatus }[];
    onStepClick: (step: number) => void;
    activeStep?: number;
    currentStep?: number;
}

const statusClasses = {
    completed: 'bg-success text-color-black',
    ongoing: 'bg-info text-color-black border-2',
    draft: 'border text-color-grey',
    current: 'bg-info text-color-black ',
};

const StepButton: React.FC<{
    stepObj: { number: number; status: StepStatus, currentStage: number };
    onStepClick: (step: number) => void;
    activeStep?: number
}> = ({ stepObj, onStepClick, activeStep }) => {
    const { number, status, currentStage } = stepObj;
    const ref = useRef<HTMLButtonElement>(null);
    const isHover = useHover(ref);

    return (
        <button
            ref={ref}
            onClick={() => onStepClick(number)}
            className={classNames(` btn btn-primary" padding-5 margin-right-10 margin-left-10
            display-flex align-items-center justify-content-center width-30 height-30 rounded-circle    ${currentStage === number ? statusClasses.current : ''}                      
            ${isHover || activeStep === number ? 'border  border-color-black border-width-2 ' : ''}                          
          `, statusClasses[status])}>
            {number}
        </button>
    );
};

const CustomStepProgress: React.FC<CustomStepProgressProps> = ({ steps, onStepClick, activeStep, currentStep }) => {
    return (
        <div className={'display-flex flex-row'}>
            {steps.map((stepObj, idx) => (
                <div key={stepObj.number} className={'display-flex align-items-baseline'}>
                    <StepButton stepObj={stepObj} onStepClick={onStepClick} activeStep={activeStep} />
                    {idx < steps.length - 1 && (
                        <div className=' height-2 width-20 bg-light '/>
                    )}
                </div>
            ))}
        </div>
    );
};

export default CustomStepProgress;
